import axios from 'axios'
import { customLogger } from "@/utils";

var apiRequest = () => {

  var token = window.localStorage.getItem("cleed_JWT");

  var environment = (window.location.hostname === '127.0.0.1' || window.location.hostname == "localhost") ?
    'dev' : 'prod'
  var urlProd = "https://" + process.env.VUE_APP_API_HOST.slice(0, -4) + "/";
  const instance = axios.create({
    baseURL: environment === 'prod'
      ? urlProd
      : 'http://localhost:48080/',
    timeout: 30000,
  })

  if (token) {
    instance.defaults.headers.common.Authorization = token;
  }

  instance.interceptors.request.use(req => {
    req.url = instance.defaults.baseURL + req.url
    return req
  })

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    function (error) {
      // Do something with response error
      if (error.response.status === 403 || error.response.status === 401) {
          customLogger("unauthorized, logging out ...");
      }
      return Promise.reject(error);
    }
  );

  return instance
}


// ===== Similarity Search Methods =====

const sauron_api = {
  base_url : 'http://ec2-13-59-73-248.us-east-2.compute.amazonaws.com',
  port: '8080',
  api_prefixe: 'api',

  lookup_uri : {
    base: 'lookup',
    paramters: {
      store_id: undefined,
      product_id: undefined
    }
  }
}

var sauron_lookup = (product, store_id, count=3, shift=0) => {

  /*customLogger([
      `Looking up product #${product.__ob__.dep.id} from store #${store_id}`,
      product
    ])*/

    let product_id = product.__ob__.dep.id;

    //================
    //   DEV VALUES
    //================

    product_id = 4758
    store_id = 16
    //===============

    // DNS + port
    let url = sauron_api.base_url + ':' + sauron_api.port + '/';

    // URL + URI (without params)
    let route = url + sauron_api.api_prefixe + '/' + sauron_api.lookup_uri.base;

    // Params
    let params = {product_id, store_id, count, shift};

    let ret = axios.get(route, {
      validateStatus: function (status) {
        return status == 200; // Resolve only if the status code is less than 500
      },
      params
    })

    return new Promise((resolve, reject) => {

      let wait = setTimeout(() => {

        clearTimeout(wait)
        reject()

      }, 1000);

      ret
        .then((res) => {
          resolve(res)
        })

    })
}


// =====================================

export { apiRequest, sauron_lookup }

